import { automationsRepo } from '@/constants/providers';
import { InfrastructureCostKey } from '@/modules/Infrastructure/queries/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { EditAutomationInfrastructureCost } from '../domain/automation-cost';
import { AutomationKey } from './keys';

export const useUpdateAutomationInfrastructureCost = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (editAutomationCost: EditAutomationInfrastructureCost) =>
      automationsRepo.updateAutomationInfrastructureCost(editAutomationCost),
    onError: () => {
      toast.error(t('error.updating_automation_cost'));
    },
    onSuccess: () => {
      toast.success(t('sucess_updating_automation_cost'));
      queryClient.invalidateQueries(AutomationKey.ALL);
      queryClient.invalidateQueries(InfrastructureCostKey.ALL);
    },
  });
};
